var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(!_vm.hasSubAccount)?_c('subconta',{attrs:{"offer":_vm.offer}}):_vm._e(),(_vm.hasSubAccount)?_c('settings',{attrs:{"offer":_vm.offer}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }